export default "__VITE_ASSET__C$yFY17R__"